import type { FC, PropsWithChildren } from 'react';
import { memo, useCallback, useMemo } from 'react';
import type { FormSpyRenderProps } from 'react-final-form';
import { FormSpy } from 'react-final-form';

import { visibleEditorValue } from '../../utils/validation';
import type { SerializedValue } from '../ThreadMessage/useSerializeValue';

// Related type: CreateOrUpdateMessageVariablesSmall
export type FormDataType = {
  content: SerializedValue;
  hiddenEmbeds: string[];
  adminBoost: boolean;
  embeds: string;
};

interface DisplayWhenValidProps {
  hasInitialValue: boolean;
  loading?: boolean;
}

export const DisplayWhenValid: FC<PropsWithChildren<DisplayWhenValidProps>> = memo(
  function DisplayWhenValid(props) {
    const { children, hasInitialValue, loading } = props;

    const render = useCallback(
      (p: FormSpyRenderProps<FormDataType>) => {
        return loading ||
          (p.hasValidationErrors === false &&
            (!p.pristine || hasInitialValue) &&
            visibleEditorValue(p.values?.content))
          ? children
          : null;
      },
      [children, hasInitialValue, loading],
    );

    return (
      <FormSpy<FormDataType>
        subscription={useMemo(
          () => ({ hasValidationErrors: true, pristine: true, values: true }),
          [],
        )}
        render={render}
      />
    );
  },
);
